var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrencyRupee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 24L1.33284 14.6667V12H5.99951C7.17729 12 8.19418 11.6164 9.05018 10.8493C9.90529 10.0831 10.4217 9.13333 10.5995 8H-0.000488281V5.33333H10.1995C9.82173 4.55556 9.26084 3.91644 8.51684 3.416C7.77195 2.91644 6.93284 2.66667 5.99951 2.66667H-0.000488281V0H15.9995V2.66667H11.6662C11.9773 3.04444 12.2551 3.45556 12.4995 3.9C12.744 4.34444 12.9328 4.82222 13.0662 5.33333H15.9995V8H13.2995C13.1217 9.88889 12.344 11.472 10.9662 12.7493C9.5884 14.0276 7.93284 14.6667 5.99951 14.6667H5.03284L13.9995 24H10.2995Z",
    fill: "#04B7B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyRupee);
export default __webpack_public_path__ + "static/media/currency_rupee.f63fc7ddec906756f9fbbdec71238bfe.svg";
export { ForwardRef as ReactComponent };